// Legacy Host executable entry (plan §5.3): owns the Vite entry, the MUI X
// license initialization, and the single-root self-mount (task 0224): the
// entry mounts the storefront app into #root_schaShell directly — the
// retired JSP queue protocol (createComponentAtId / markReactReady) is
// gone. Imports Core ONLY through the transitional legacy subpath — never
// Core filesystem internals.
import { LicenseInfo } from "@mui/x-license";
import {
  initializeLegacyRuntime,
  mountStorefrontApp,
  finalizeLegacyBoot,
} from "@schaeffler-commerce/core/legacy-runtime";

LicenseInfo.setLicenseKey(
  "80035531017802fcf9a758e1079b8621Tz0xMjAxOTQsRT0xNzkxNTkwMzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=",
);

initializeLegacyRuntime();

mountStorefrontApp();

finalizeLegacyBoot();
